import { render, staticRenderFns } from "./TestingCenterCard.vue?vue&type=template&id=bde8599e&"
import script from "./TestingCenterCard.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports